import { GoogleAnalyticsEventsService } from './../../../services/google-analytics-events.service';
import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss']
})
export class FilterTagsComponent {
  
  // paramMap = {};
  // var obj = arr.reduce(function(acc, cur, i) {
  //   acc[i] = cur;
  //   return acc;
  // }, {});
  @Input() paramMap: any;
  @Input() searchText: string;
  @Input() filters: any;
  @Input() pageName: string;

  @Output() removeFilter: EventEmitter<any>;
  @Output() removeSearchText: EventEmitter<any>;

  constructor(private googleAnalyticsService: GoogleAnalyticsEventsService) {
    this.removeFilter = new EventEmitter();
    this.removeSearchText = new EventEmitter();
  }

  getLabel(key: string) {
    let _filters = [];

    try {
      Object.keys(this.filters).map(x => {
        _filters = _filters.concat(this.filters[x].items);
      });
    } catch (error) {
      console.error('get.label', key, error.message);
    }

    const _filter = _filters.filter(x => x.name === key).pop();
    return _filter ? _filter.label : key;
  }

  onRemoveFilter(event, tag) {
    event.preventDefault();
    this.removeFilter.emit(tag);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Breadcrumb'), 'Icon Click', 'Breadcrumb removed');
  }

  onRemoveSearchText(event, tag) {
    event.preventDefault();
    this.removeSearchText.emit(tag);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Breadcrumb'), 'Icon Click', 'Breadcrumb removed');
  }
}
